import {
  DataResult,
  DataStream,
  DataStreamTimeSeriesData,
  WidgetSettingsType,
} from '@thingslog/repositories';
import { DataResultParseStrategy } from './DataResultParseStrategy';
import { DataResultParsed, DataResultParseStream } from '../DataResultParsed';
import {
  applySingleUnitYAxisFormatter,
  createUnitTooltipFormatter,
  getStreamLabel,
  getStreamUnit,
} from '../metadata';
import { formatTooltipValue } from '../../utils/chartDateFormatters';
import { t } from 'i18next';

const COLOR_PALETTE = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#8884D8',
  '#82CA9D',
  '#FFC658',
  '#FF6B6B',
];

export class ApiDeviceReadingDataResultParseStrategy implements DataResultParseStrategy {
  public parse(dataResult: DataResult, widgetType: WidgetSettingsType): DataResultParsed {
    const parsed: DataResultParsed = {
      dataStreams: [],
      xAxis: {
        show: true,
        dataKey: 'date',
        formatter: (value: string) => value,
      },
      yAxis: {
        show: true,
        dataKey: 'value',
        formatter: (value: number) => value.toString(),
      },
      legend: {
        show: true,
      },
    };

    const units = new Set<string>();
    let streamIndex = 0;

    dataResult.streams.forEach((stream: DataStream) => {
      if (stream.type !== 'timeseries') return;

      const streamLabel = getStreamLabel(
        stream,
        t('dashboard_series_index', 'Series {{index}}', { index: streamIndex + 1 })
      );
      const unit = getStreamUnit(stream);

      if (unit) {
        units.add(unit);
      }

      const color = COLOR_PALETTE[streamIndex % COLOR_PALETTE.length];

      const dataStream: DataResultParseStream = {
        data: [],
        visualization: [
          {
            dataKey: 'value',
            fill: color,
            innerRadius: 70,
            outerRadius: 90,
            nameKey: 'date',
            name: streamLabel,
            unit,
          },
        ],
      };

      stream.data.forEach((data: DataStreamTimeSeriesData) => {
        dataStream.data.push({
          date: data.date,
          value: data.value,
        });
      });

      parsed.dataStreams.push(dataStream);
      streamIndex++;
    });

    applySingleUnitYAxisFormatter(parsed, units);
    parsed.tooltip = {
      formatter: createUnitTooltipFormatter(),
      labelFormatter: (value: string | number) => formatTooltipValue(value),
    };

    return parsed;
  }
}
